















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { cloneDeep } from 'lodash';

@Component
export default class UiToggleStatus extends BaseComponent {
  @Prop()
  public item: any;
  @Prop()
  public status: boolean;
  @Prop({
    default: false,
  })
  public disabled: boolean;

  @Prop({
    default: true,
  })
  public confirm: boolean;

  public toggleItemStatus(): void {
    const updateItem = () => {
      this.$emit('change', this.item, !this.status);
    };

    if (this.confirm) {
      this.dialog.show(
        'error',
        'Alterar status',
        'Tem certeza que deseja alterar o status deste item?',
        'Cancelar',
        '',
        'Alterar',
        updateItem,
      );
    } else {
      updateItem();
    }
  }
}
